import React, { useContext, useEffect, useRef, useState } from 'react';
import ClubListItem from '../ClubListItem/ClubListItem';
import clubImage from '../../../assets/images/iron-serial.png';
import Caret from '../../../assets/images/icons/caret-right.svg';
import Checkmark from '../../../assets/images/icons/checkmark.svg';
import Edit from '../../../assets/images/icons/edit.svg';
import Delete from '../../../assets/images/icons/trash.svg';
import { LocalizationContext } from '../../../context/localizationContext';
import { clubsContext } from '../../../context/clubsContext';
import { notificationContext } from '../../../context/notificationContext';
import ClubModal from '../../ClubModal/ClubModal';
import getClubImage from '../../../helpers/ClubImageHelper';
import Styles from './ClubListGroup.module.scss';
import APIClient from '../../../helpers/APIClient';

const ClubListGroup = (props) => {
  const { club, registered, updateSelectedClubsList, isTileView } = props;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { clubItemTxt, modal, notification } = localizationState.localization;
  const { dispatch } = useContext(clubsContext);
  const { notificationState, notificationDispatch } =
    useContext(notificationContext);
  const { addedClubSerial, isOpen } = notificationState;
  const [showAllClubs, setShowAllClubs] = useState(false);
  const editActionsRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const unregisterMasterSerialNumber = () => {
    setIsEditing(false);
    setModalOpen(false);
    if (club?.masterSerialNumber) {
      APIClient.unregisterMasterSerialNumber(
        club.masterSerialNumber,
        (unregisterStatus) => {
          if (unregisterStatus === 200) {
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notification?.unregisterSuccess,
              icon: 'checkmark',
            });
            APIClient.getAllSerials((status, resp) => {
              if (status === 200) {
                dispatch({ type: 'SET_USER_CLUBS', clubs: resp.data });
              } else {
                notificationDispatch({
                  type: 'SET_NOTIFICATION',
                  isOpen: true,
                  message: notification?.getClubsError,
                  icon: 'error',
                });
              }
            });
          } else {
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notification?.unregisterError,
              icon: 'error',
            });
          }
        }
      );
    }
  };

  const editActionList = [
    {
      label: clubItemTxt?.removeSet,
      action: () => setModalOpen(true),
    },
  ];

  const renderClubs = (clubs) => {
    if (Array.isArray(clubs)) {
      return clubs.toString().replace(/,/g, ', ');
    }
    return clubs;
  };

  const handleClickOutside = (e) => {
    if (!editActionsRef?.current?.contains(e.target)) {
      setIsEditing(false);
    }
  };

  const getClubGroup = (isModalItem) => {
    return (
      <div
        className={`
      ${Styles.item}
      ${registered ? Styles.shadow : Styles.border}
      ${isModalItem && Styles.modalItem}
      ${
        isOpen &&
        addedClubSerial?.includes(club?.serialNumber) &&
        registered &&
        !isTileView
          ? Styles.newlyAddedClub
          : ''
      }
      `}
      >
        <div className={Styles.itemContent}>
          {/* This might be used later depending on if we want a checkbox for serial group items */}
          {/* <div className={Styles.itemContentLeft}> */}
          {/* {!registered && (
              <input
                type='checkbox'
                className={Styles.check}
                onClick={(e) => updateSelectedClubsList(
                  club,
                  e.target.checked,
                )}
              />
            )} */}
          <div className={Styles.clubImageContainer}>
            <img
              className={`${Styles.clubImage} ${
                club?.moreDetailsLink ? Styles.cursor : ''
              }`}
              onClick={() =>
                club?.moreDetailsLink !== '' &&
                window.open(club?.moreDetailsLink, '__blank')
              }
              src={
                club?.imagePath !== ''
                  ? club?.imagePath
                  : getClubImage(club?.productFormatted)
              }
              alt="club"
              onError={({ currentTarget }) => {
                if (
                  currentTarget.src !== getClubImage(club?.productFormatted)
                ) {
                  currentTarget.onerror = null;
                  currentTarget.src = getClubImage(club?.productFormatted);
                }
              }}
            />
          </div>
          <div className={Styles.descriptionAndRegistrationDate}>
            <div className={Styles.description}>
              <div className={Styles.product}>
                {club?.productFormatted}
                {club?.clubList?.length && !isModalItem && (
                  <div className={Styles.setNumber}>
                    {`${clubItemTxt?.setNumber} ${club.clubList.length}`}
                  </div>
                )}
              </div>
              <div className={Styles.model}>{club?.modelFormatted}</div>
              <div
                className={`
              ${Styles.clubList}
              ${isTileView ? Styles.tile : ''}
              `}
              >
                {club?.clubList && renderClubs(club.clubList)}
              </div>
              {club?.serialNumber && (
                <div className={Styles.serialLabel}>
                  {clubItemTxt?.serialNumber}:
                  <span className={Styles.serial}>{club.serialNumber}</span>
                </div>
              )}
            </div>
            {!isModalItem && !isTileView && (
              <div className={Styles.registeredLabel}>
                <img
                  className={Styles.checkmark}
                  src={Checkmark}
                  alt={'check'}
                />
                <div className={Styles.text}>{clubItemTxt?.registeredLbl}</div>
              </div>
            )}
          </div>
          {!isTileView && registered && !isModalItem && (
            <div className={Styles.editActionsWrapper} ref={editActionsRef}>
              <div
                className={Styles.editButton}
                onClick={() => setIsEditing(!isEditing)}
              >
                <img className={Styles.editIcon} src={Edit} alt="edit" />
              </div>
              {(isEditing || modalOpen) && (
                <div className={Styles.editActions}>
                  {editActionList?.map((item, i) => {
                    return (
                      <button
                        key={i}
                        className={Styles.editActionBtn}
                        type="button"
                        onClick={() => item.action && item.action()}
                      >
                        <img src={Delete} alt="delete" />
                        {item.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
        {!isTileView && !isModalItem && (
          <>
            <div className={Styles.viewClubsGroupBtn}>
              <div onClick={() => setShowAllClubs(!showAllClubs)}>
                <img
                  className={`${Styles.caret} ${
                    showAllClubs ? Styles.rotate : ''
                  }`}
                  src={Caret}
                  alt={'caret'}
                />
                {clubItemTxt.viewAllClubs}
              </div>
            </div>
            {showAllClubs && (
              <div className={Styles.clubGroup}>
                {club?.clubs?.map((clubItem, i) => {
                  return (
                    <div key={i}>
                      <ClubListItem
                        club={clubItem}
                        registered={registered}
                        updateSelectedClubsList={updateSelectedClubsList}
                        groupItem={true}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  return (
    <div>
      {club && getClubGroup()}
      <ClubModal
        isOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalMessage={modal?.deleteSet}
        okText={modal?.removeSet}
        okClick={unregisterMasterSerialNumber}
      >
        {club && getClubGroup(true)}
      </ClubModal>
    </div>
  );
};

export default ClubListGroup;
